import React from "react";
import { Grid } from "@mui/material";

export const FormRow: React.FC<Omit<React.HTMLProps<HTMLDivElement>, "wrap" | "ref">> = props => (
  <Grid container spacing={1} {...props}>
    {props.children}
  </Grid>
);
